import * as React from 'react';
import { Grid, StyledComponentProps, withStyles } from '@material-ui/core';
import { tag } from '../../../../model/tag';
import TextField from '../../../../ui-components/TextField/TextField';
import Button from '../../../../ui-components/Button/Button';
import { styles } from './styles';
import NewItemButton from '../../../../ui-components/Button/NewItemButton';

interface IProps extends StyledComponentProps {
    handleChangeFullnameOrEmail: (val: string) => void;
    handleChangeSub: (val: string) => void;
    handleChangeTagCode: (val: tag) => void;
    search: (page: number, fullnameOrEmail?: string, tag?: tag) => void;
    new: () => void;
    fullnameOrEmail?: string;
    sub?: string;
    loading: boolean;
    selctedTag?: tag;
}

// const searchTagsSearchBox = (search: string, take?: number): Promise<Array<tag>> => {
//     return new Promise((resolve, reject) => {
//         invokeApi({
//             path: take ? `/api/Contacts/tags?codeOrDescription=${search}&take=${take}` : `api/Contacts/tags?codeOrDescription=${search}`,
//             method: 'GET',
//             responseType: "json",
//         }).then(val => {
//             resolve(val);
//         }).catch(val => {
//             reject(val)
//         })
//     })
// }

// const templateSearchBoxTag = (tag?: tag) => {
//     return tag ? {
//         label: (tag.code ? tag.code + " - " : "") + tag.description,
//         value: tag
//     } : undefined;
// }

class Filters extends React.Component<IProps>
{

    render() {
        const classes = this.props.classes;
        return (<Grid container className={classes.root} spacing={2}>
            <Grid item xs={9} sm={8} >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} >
                        <TextField label='Cognome Nome o Email'
                            onKeyDown={(e) => {
                                //Enter KeyCode = 13
                                if (e.keyCode === 13) {
                                    this.props.search(0, this.props.fullnameOrEmail, this.props.selctedTag)
                                }
                            }}
                            disabled={this.props.loading} 
                            onChange={this.props.handleChangeFullnameOrEmail} 
                            value={this.props.fullnameOrEmail} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                    <TextField label='Sub'
                            // onKeyDown={(e) => {
                            //     //Enter KeyCode = 13
                            //     if (e.keyCode === 13) {
                            //         this.props.search(0, this.props.fullnameOrEmail, this.props.selctedTag)
                            //     }
                            // }}
                            disabled={this.props.loading} onChange={this.props.handleChangeSub} value={this.props.sub} />
                    </Grid>
                        {/* <SearchBoxApi<tag>
                            selectedItem={this.props.selctedTag}
                            openOnFocus
                            doFilter
                            disabled={this.props.loading}
                            listSize={10}
                            onValueSubmit={(item) => {
                                this.props.handleChangeTagCode(item)
                                this.props.search(0, this.props.fullnameOrEmail, item)

                            }}
                            getItems={searchTagsSearchBox}
                            label={"Tag"}
                            placeholder={"Digitare descrizione o codice"}
                            templateItem={templateSearchBoxTag}
                            onSelectedChange={(item) => { this.props.handleChangeTagCode(item) }} /> */}
                        {/* <TextField label='Tags' onChange={this.props.handleChangeTagCode} value={this.props.tagCode} /> */}
                </Grid>
            </Grid>
            <Grid item xs={3} sm={4} className={classes.searchButtons} >
                <div className={classes.searchButton}>
                    <Button className={classes.searchButton} onClick={() => this.props.search(0, this.props.fullnameOrEmail, this.props.selctedTag)}>Cerca</Button>
                </div>
                <div className={classes.searchButton}>
                    <NewItemButton disabled={this.props.loading} onClick={() => this.props.new()} text="Nuovo" />
                </div>
            </Grid>
        </Grid>
        );
    }
}

export default withStyles(styles)(Filters)